// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Zq-z","imageAndVideoCount":"_q-z","imageAndVideoContainer":"ar-z","viewAllReviews":"br-z"};